/*
 * @Author: yuanweijiang
 * @Date: 2023-11-21 14:57:17
 * @LastEditors: yuanweijiang
 */
import axios from 'axios'
import store from '@/store'
import router from '@/router' // 引入 router
import { Message, Loading } from 'element-ui'

// let url = location.href;
// let baseUrl = url.substring(0, url.lastIndexOf("/"));
// 初始化配置
let config = {
    baseURL: process.env.VUE_APP_API_PRE,
    withCredentials: false,
    timeout: 10000
}
let instance = axios.create(config)
let loadingInstance = null
let pendingCount = 0
let showTimer = null
let closeTimer = null
const originalXHROpen = XMLHttpRequest.prototype.open
const originalXHRSend = XMLHttpRequest.prototype.send
XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this._url = url
    this._method = method
    return originalXHROpen.call(this, method, url, ...args)
}

XMLHttpRequest.prototype.send = function (...args) {
    if (this._url && this._url.includes('/file/proxy')) {
        // 添加token到请求头
        const token = store.state.user.token
        if (token) {
            this.setRequestHeader('Authorization', 'Bearer ' + token)
        }
    }
    return originalXHRSend.call(this, ...args)
}

// Fetch 拦截
const originalFetch = window.fetch

window.fetch = async function (...args) {
    const [resource, config = {}] = args

    // 获取 URL
    const url = resource instanceof Request ? resource.url : resource

    // 检查是否需要添加 token
    if (url && url.includes('/file/proxy')) {
        const token = store.state.user.token
        if (token) {
            // 创建新的配置对象
            const newConfig = {
                ...config,
                headers: {
                    ...(config.headers || {}),
                    Authorization: `Bearer ${token}`
                }
            }

            // 如果 resource 是 Request 对象，创建新的 Request
            if (resource instanceof Request) {
                const newRequest = new Request(resource, newConfig)
                return originalFetch(newRequest)
            }

            return originalFetch(resource, newConfig)
        }
    }

    return originalFetch(resource, config)
}

// 添加请求拦截器
instance.interceptors.request.use(
    function (config) {
        let accessToken = store.state.user.token
        if (config.headers.Authorization != 'Basic Z2VuOmdlbg==') {
            if (accessToken) {
                config.headers.Authorization = 'Bearer ' + accessToken
            }
        }
        // 请求初始化配置
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)
// 添加响应拦截器
// 添加响应拦截器
instance.interceptors.response.use(
    (response) => {
        let data = response.data
        if (data.code == 0 || data.code == 200 || data.access_token) {
            return data || {}
        } else if (data.code == '100004') {
            Message.warning('请登录账号')
            return Promise.reject(response.data)
        } else {
            Message.warning(data.msg)
            return Promise.reject(response.data)
        }
    },
    (error) => {
        if (error.response && (error.response.status === 424 || error.response.status === 401)) {
            Message.warning('请求令牌已过期')
            localStorage.clear()
            sessionStorage.clear()
            const ssoLoginUrl = '/authapi/auth/oauth2/authorize'
            const redirectUri = encodeURIComponent(window.location.origin + '/sso')
            const ssoUrl = `${ssoLoginUrl}?scope=server&redirect_uri=${redirectUri}&response_type=code&client_id=sscity`
            window.location.href = ssoUrl
            return Promise.reject(error)
        }
        if (error.response?.status === 413) {
            Message.warning('上传数据量过大，请减少数据量后重试')
            return Promise.reject(error)
        }
        if (error.code === 'ECONNABORTED') {
            Message.warning('网络请求超时!')
        } else if (error.response?.data?.msg) {
            Message.warning(error.response.data.msg)
        } else if (error.request && error.request.status == 0) {
            Message.warning('网络异常!')
        } else if (error.response) {
            Message.warning('网络请求错误:' + error.response.status)
        } else {
            Message.warning('网络请求错误')
        }
        return Promise.reject(error)
    }
)
const request = (url, method, params = {}, config = {}) => {
    return new Promise((resolve, reject) => {
        const startTime = new Date().getTime()
        const { target, timeout, ...axiosConfig } = config
        let isError = false

        pendingCount++
        clearTimeout(closeTimer)
        if (pendingCount === 1 && !loadingInstance) {
            showTimer = setTimeout(() => {
                if (!window.noLoading) {
                    loadingInstance = Loading.service({ target, background: 'rgba(0, 0, 0, 0.2)' })
                }
            }, 200)
        }

        if (timeout) {
            axiosConfig.timeout = timeout
        }
        instance[method](
            url,
            ['get', 'GET', 'delete', 'DELETE'].includes(method)
                ? {
                      params,
                      paramsSerializer: function (params) {
                          return Object.keys(params)
                              .map(function (key) {
                                  return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                              })
                              .join('&')
                      }
                  }
                : params,
            axiosConfig
        )
            .then((response) => {
                if (response.code == 0 || response.code == 200 || response.access_token) {
                    resolve(Object.keys(response).find((key) => key === 'data') ? response.data : response)
                } else {
                    reject(response)
                }
            })
            .catch((error) => {
                isError = true
                reject(error)
            })
            .finally(() => {
                pendingCount--
                if (pendingCount > 0) return

                clearTimeout(showTimer)
                clearTimeout(closeTimer)
                if (!loadingInstance) return

                if (isError) {
                    const elapsed = new Date().getTime() - startTime
                    if (elapsed >= 800) {
                        loadingInstance.close()
                        loadingInstance = null
                    } else {
                        closeTimer = setTimeout(() => {
                            loadingInstance.close()
                            loadingInstance = null
                        }, 800 - elapsed)
                    }
                } else {
                    loadingInstance.close()
                    loadingInstance = null
                }
            })
    })
}

export default request
